import {SubscriptionTypes} from '../ActionTypes/SubscriptionTypes';

class SubscriptionActions {
  static getSubscriptionHistory = payload => {
    return {
      type: SubscriptionTypes.GET_SUBSCRIPTION_HISTORY,
      payload: payload,
    };
  };

  static clearSubscriptionHistory = () => {
    return {
      type: SubscriptionTypes.CLEAR_SUBSCRIPTION_HISTORY,
    };
  };
}

export default SubscriptionActions;
